import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react'
import { cn } from '~/shadcn/lib/utils'
import { Button } from '~/shadcn/ui/button/button'
import { Text } from '~/@mid_ui/typography/Text'
import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { HeadingTwo } from '~/@mid_ui/typography/HeadingTwo'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { useUser } from '~/@biz_account/useUser/useUser'
import { menuItems } from './menuItems'

interface ProfileMenuProps {
  activeRoute: string
}
export const SettingsMenu = ({ activeRoute }: ProfileMenuProps) => {
  const { user } = useUser()
  const isDesktop = useIsDesktop()
  const [isCollapsed, setIsCollapsed] = useState(true)

  const activeRouteLabel = menuItems.find(
    (item) => item.route === activeRoute
  )?.label

  if (user == null) return null

  return (
    <>
      {!isDesktop && (
        <PageContainer className="pt-[60px] pb-5 md:pt-20 md:pb-5 border-b border-border">
          <Button
            type="button"
            variant="ghost"
            className="w-full p-0"
            onClick={() => setIsCollapsed((prev) => !prev)}>
            <div className="flex flex-row justify-between items-center w-full">
              <HeadingTwo className="text-[40px] leading-[52px] text-primary">
                Nastavenia
              </HeadingTwo>
              {isCollapsed ? (
                <ChevronDownIcon className="w-10 h-10 text-primary" />
              ) : (
                <ChevronUpIcon className="w-10 h-10 text-primary" />
              )}
            </div>
          </Button>
        </PageContainer>
      )}

      {((!isCollapsed && !isDesktop) || isDesktop) && (
        <div className="flex pt-10 flex-col items-start gap-5 self-stretch xl:w-100">
          <div className="w-full">
            {menuItems
              .filter((item) => item.isVisible?.(user) ?? true)
              .map(({ label, route, Icon }) => {
                const isActive = activeRoute === route
                return (
                  <Link
                    key={route}
                    type="button"
                    className={cn(
                      'relative w-full px-7 py-4 flex flex-row gap-2 text-base font-semibold leading-[26px] transition-colors',
                      'cursor-pointer relative flex-start',
                      'hover:bg-gray-100',
                      isActive
                        ? 'text-primary before:content-[""] before:block before:absolute before:bottom-0 before:left-[-3px] before:h-full before:w-1.5 before:z-1 before:bg-accent'
                        : 'text-muted'
                    )}
                    onClick={() => setIsCollapsed(true)}
                    to={route}>
                    <div
                      className={cn(
                        'absolute top-0 left-0 w-1.5 -ml-[3px] h-full z-1 bg-accent transition-all duration-300 origin-center',
                        isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
                      )}
                    />
                    <div
                      className={cn(
                        'flex items-center',
                        isActive ? 'text-primary' : 'text-muted'
                      )}>
                      <div className="flex w-6 h-6 justify-center items-center">
                        <Icon
                          className={isActive ? 'text-accent' : 'text-primary'}
                        />
                      </div>
                    </div>
                    <Text>{label}</Text>
                  </Link>
                )
              })}
          </div>
        </div>
      )}
      {!isDesktop && activeRouteLabel && (
        <PageContainer className="pt-[60px] pb-5 lg:pt-20 lg:pb-5 border-b border-border">
          <HeadingTwo className="text-[40px] leading-[52px] text-primary">
            {activeRouteLabel}
          </HeadingTwo>
        </PageContainer>
      )}
    </>
  )
}
